<template>
  <ChangePasswordWrapper>
    <sdCards>
      <template v-slot:title>
        <div class="setting-card-title">
          <sdHeading as="h4">{{ $t('pages.settings.change-password') }}</sdHeading>
          <span>{{ $t('pages.settings.change-password-desc') }}</span>
        </div>
      </template>
      <a-row type="flex" justify="center">
        <a-col :lg="12" :sm="20" :xs="24">
          <BasicFormWrapper>
            <a-form :model="formState" @finish="handleFinish">
              <a-form-item :label="$t('pages.settings.old-password')">
                <a-input-password v-model:value="formState.old" required />
              </a-form-item>
              <a-form-item name="new" :label="$t('pages.settings.new-password')">
                <a-input-password v-model:value="formState.new" required />
              </a-form-item>
              <a-form-item name="new-confirm" :label="$t('pages.settings.new-password-confirm')">
                <a-input-password v-model:value="formState.confirm" required />
              </a-form-item>
              <a-form-item>
                <sdButton htmlType="submit" type="primary"> {{ $t('pages.settings.save-change') }} </sdButton>
              </a-form-item>
            </a-form>
          </BasicFormWrapper>
        </a-col>
      </a-row>
    </sdCards>
  </ChangePasswordWrapper>
</template>

<script>
import { ChangePasswordWrapper } from './style';
import { BasicFormWrapper } from '../../styled';

export default {
  name: 'Password',
  data() {
    return {
      formState: {
        old: null,
        new: null,
        confirm: null,
      },
    };
  },
  components: { ChangePasswordWrapper, BasicFormWrapper },
  methods: {
    handleFinish() {
      if (this.formState.new != this.formState.confirm) {
        this.$message.error(this.$t('pages.settings.not-matched'));
        return false;
      }
      const form = {
        old: this.formState.old,
        new: this.formState.new,
        confirm: this.formState.confirm,
      };
      this.$appAxios.post(this.$endpoints.profile_password_set, form).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
};
</script>
